import { render, staticRenderFns } from "./workBench.vue?vue&type=template&id=4b4dfdf6&scoped=true"
import script from "./workBench.vue?vue&type=script&lang=js"
export * from "./workBench.vue?vue&type=script&lang=js"
import style0 from "./workBench.vue?vue&type=style&index=0&id=4b4dfdf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dfdf6",
  null
  
)

export default component.exports